import { PropsWithChildren } from "react";

export default function ReturnDetailsHeaderLabel({
  children,
}: PropsWithChildren) {
  return (
    <span className="text-sm font-medium text-muted-foreground inline-flex items-center gap-2">
      {children}
    </span>
  );
}
